import React from "react"
import { CarouselComponent } from "../CarouselComponent"

export const ParamountWelcomeComponent = () => {
  return (
    <CarouselComponent height="100vh" bgPosition="top center" images={["/images/Paramount/landing_desktop.jpg"]}>
        <div className="row">
          <div className="col mx-auto">
            <p className="text-center title-paramount">Redeem your Paramount+ offer and start streaming a Mountain of Entertainment now!</p>
          </div>
        </div>
    </CarouselComponent>
  )
}
